import gql from "graphql-tag";

export default gql`
  mutation QueryGatewayLogin($token: String!) {
    userId: login(token: $token)
  }
`;
